export { default } from './CamListItemSpotInfo';
